export default __webpack_public_path__ + "static/media/flor2.a2e86fd1.jpeg";